import React, { useEffect, useState } from "react";
import axios from "axios";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "../ui/switch";
import { API, auth, enablePush, getPlan, tz } from "./practiceApi";

// Optional bedtime reminder that opens this Night Version. Off until the member turns it on.
export const BedtimeNudge = ({ journeyId }) => {
  const [b, setB] = useState(undefined);
  const [plan, setPlan] = useState(null);
  useEffect(() => {
    axios.get(`${API}/api/night/bedtime`, auth()).then((r) => setB(r.data.bedtime)).catch(() => setB(null));
    getPlan().then(setPlan).catch(() => {});
  }, []);
  if (b === undefined) return null;
  if (plan?.reminders && plan.day <= plan.days) {
    return <p className="mt-2 text-xs text-[#9fb39a]" data-testid="bedtime-plan-note">Your 21-Day plan already reminds you at bedtime.</p>;
  }
  const on = !!b?.enabled && b.journey_id === journeyId;
  const time = b?.time || "22:00";
  const save = async (enabled, t = time) => {
    if (enabled) {
      const r = await enablePush().catch(() => "unsupported");
      if (r !== "ok") { toast.error("Please allow notifications on this device to get a bedtime reminder."); return; }
    }
    try {
      const r = await axios.put(`${API}/api/night/bedtime`, { enabled, time: t, tz: tz(), journey_id: journeyId }, auth());
      setB(r.data.bedtime);
      if (enabled) toast.success(`We'll gently remind you at ${t}.`);
    } catch { toast.error("Couldn't save your bedtime reminder."); }
  };
  return (
    <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-[#cfc6ae]" data-testid="bedtime-nudge">
      <BellRing size={14} className="text-[#d7bb7a]" />
      <span>Bedtime reminder</span>
      <Switch checked={on} onCheckedChange={(v) => save(v)} data-testid="bedtime-nudge-switch" />
      {on && (
        <input type="time" value={time} onChange={(e) => e.target.value && save(true, e.target.value)} data-testid="bedtime-nudge-time"
          className="rounded-lg border border-[#2b3d5e] bg-transparent px-2 py-1 text-[#f3ecd9] [color-scheme:dark]" />
      )}
    </div>
  );
};
